import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../_common/_service/authservice.service';
@Component({
  selector: 'app-flutterbankresponse',
  templateUrl: './Flutterbankresponse.component.html',
  styleUrls: ['./Flutterbankresponse.component.scss']
})
export class FlutterBankresponseComponent implements OnInit {

  userresponsemsg: any;
  userresponsestatus: any;
  beneficiarynumber: any;
  entryDate: any;
  eziPayReferenceId: any;
  remark: any;
  totalAmount: any;
  merchantCode: any;
  transactionStatus: any;

  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(params => {
      
      //{ "status": "successful", "tx_ref": "EZB-2022-1072069", "transaction_id": "632764155", "flag": null }
      let status = params['status'];
      let tx_ref = params['tx_ref'];
      let transaction_id = params['transaction_id'];

      if (status == "successful" && tx_ref != null && tx_ref != undefined && transaction_id != null && transaction_id != undefined) {

        this.FlutterSubmitBankresponseapi(status, tx_ref, transaction_id);//CAll API       

      }
    });
  }

  FlutterSubmitBankresponseapi(status: any, tx_ref: any, transaction_id: any) {
    ;
    this.authService.FlutterSubmitBankresponseapi(status, tx_ref, transaction_id).subscribe(response => {

      ////////console.log(response);
      this.userresponsestatus = response.apiStatus;
      this.merchantCode = response.apiStatusCode;
      if (response.apiStatus == true) {
        if (response.apiStatusCode == "M") {
          window.location.href = response.apiData;
        }
        else {

          this.beneficiarynumber = response.apiData.beneficiarynumber;
          this.entryDate = response.apiData.entryDate;
          this.eziPayReferenceId = response.apiData.eziPayReferenceId;
          this.remark = response.apiData.remark;
          this.totalAmount = response.apiData.totalAmount;
          this.transactionStatus = response.apiData.transactionStatus;

        }
      }
      else {

        this.userresponsemsg = response.apiMessage;
      }
    });
  }
}
